<template>
  <div class="street-input-component">
    <vue-suggest
      ref="suggestComponent"
      v-model="model"
      :destyled="true"
      :list="getList"
      :min-length="3"
      :debounce="400"
      :filter-by-query="false"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        showList: [40],
        hideList: [27, 35],
      }"
      :mode="mode"
      :nullable-select="false"
      placeholder=""
      value-attribute="id"
      display-attribute="rawValue"
      :disabled="disabled"
      @select="onSuggestSelect"
      @input="onInput"
    >
      <template v-slot:misc-item-above="{ suggestions, query }">
        <div
          v-if="suggestions.length > 0 && !loading"
          class="misc-item items-found"
        >
          <span>Выберите адрес из списка</span>
        </div>
        <div v-else-if="!loading" class="misc-item misc-item--not-found">
          <span>Ничего не найдено по запросу "{{ query }}"</span>
          <v-btn
            color="success"
            depressed
            large
            class="choose-on-map-btn"
            @mousedown.prevent="onChooseOnMap"
          >
            Указать на карте
          </v-btn>
        </div>
      </template>

      <template v-slot:suggestion-item="scope">
        <div class="suggestion-item__text">
          <div v-html="getSuggestItem(scope)"></div>
        </div>
      </template>

      <div v-if="loading" slot="misc-item-below" class="misc-item">
        <span>Поиск...</span>
      </div>
    </vue-suggest>
  </div>
</template>

<script>
  import VueSuggest from 'vue-simple-suggest'

  export default {
    name: 'StreetWithCityInput',
    components: {
      VueSuggest,
    },
    emits: ['selected', 'input', 'clear-obj', 'choose-coordinates'],
    props: {
      placeholder: {
        type: String,
        default: '',
      },
      initVal: {
        type: String,
        default: '',
      },
      regionId: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        selected: null,
        model: null,
        mode: 'input',
        loading: false,
        log: [],
      }
    },
    computed: {
      val () {
        return this.model
      },
    },
    watch: {
      regionId (newValue, oldValue) {
        if (oldValue && newValue !== oldValue) {
          this.selected = null
          this.onSuggestSelect(null)
          this.$emit('clear-obj')
          this.model = null
        }
      },
      /* val (newValue) {
        if (this.selected && this.selected.street !== newValue) {
          /!* console.log('clearStreet')
          console.log({
            selected: this.selected,
            value: this.selected ? this.selected.value : '---',
            newValue: newValue,
          }) *!/
          this.selected = null
          this.onSuggestSelect(null)
          this.$emit('input', this.model)
        }
      }, */
    },
    created () {
      if (this.initVal) {
        this.model = this.initVal
      }
    },

    methods: {
      getSuggestItem (scope) {
        if (!scope) {
          return scope
        }
        const { suggestion, query } = scope

        const result = this.$refs.suggestComponent.displayProperty(suggestion)

        if (!query) {
          return result
        }

        const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || ['']
        return result.replace(
          new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'),
          '$1<b>$2</b>$3',
        )
      },
      getCity (scope) {
        if (!scope) {
          return scope
        }

        const { suggestion } = scope

        return suggestion.city
      },

      getList (query) {
        this.loading = true
        return this.$store
          .dispatch('suggests/getSuggestStreetWithCity', {
            query,
            cityId: this.regionId,
          })
          .finally(() => {
            this.loading = false
          })
      },
      onSuggestSelect (suggest) {
        console.log({ suggest })
        this.$emit('selected', suggest)
        this.selected = suggest
      },
      onInput () {
        this.$nextTick(() => {
          this.$emit('input', this.model)
        })
      },
      onChooseOnMap () {
        if (this.$refs.suggestComponent) {
          this.$refs.suggestComponent.hideList()
        }
        this.$emit('choose-coordinates')
      },
      setModel (text) {
        this.model = text || null
      },
    },
  }
</script>

<style lang="less">
.street-input-component {
  position: relative;

  .input-text_input,
  .default-input {
    height: 80px;
    background-color: @color-secondary !important;
    border-radius: 15px;
    font-size: 25px;
    line-height: 18px;
    outline: none;
  }

  .text-field {
    &.v-input--is-focused {
      .v-input__slot {
        border: 2px solid #ff9500;
      }
    }

    .v-input__slot {
      height: 80px;
      background-color: @color-secondary !important;
      border-radius: 15px;

      input {
        font-size: 25px;
        line-height: 18px;
        outline: none;
      }
    }
  }

  b {
    font-weight: bold;
  }

  .vue-simple-suggest {
    &.focus .input-wrapper input {
      border: 2px solid #ff9500;
    }

    .suggestions {
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      //top: calc(100% + 5px);
      //border: 1px solid #e1e1e1;
      background-color: #fff;
      opacity: 1;
      z-index: 1000;
      max-height: 340px;
      overflow-y: auto;
      //box-shadow: 0 3px 14px rgb(128 128 128 / 16%);
      border-radius: 15px;
      font-size: 16px;
      list-style: none;
      margin: 0;
      padding: 0;
      /*box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
      0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12);*/
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.3);

      .misc-item {
        span {
          margin-bottom: 0;
        }

        &.items-found {
          color: #fe7e00;
          //font-weight: 500;
        }

        &--not-found {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
        }

        .choose-on-map-btn {
          flex-shrink: 0;
          border-radius: 10px;
        }
      }
    }

    .suggestions .suggest-item {
      cursor: pointer;
      user-select: none;
      font-size: 16px;
      padding-top: 10px;
      padding-bottom: 10px;
      border-top: 1px solid #f2f2f2;

      .area {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 4px;
      }
    }

    .suggestions .suggest-item,
    .suggestions .misc-item {
      padding: 10px 10px;
    }

    .suggestions .suggest-item.hover {
      background-color: #f2f2f2 !important;
      // color: #fff !important;
    }
  }
}
</style>
